import React__default, { useState, useEffect } from 'react';
import styled from '../../../node_modules/@mui/material/styles/styled.js';
import MuiTabs from '../../../node_modules/@mui/material/Tabs/Tabs.js';
import Tab from '../../../node_modules/@mui/material/Tab/Tab.js';

const AntTabs = styled(MuiTabs, {
    shouldForwardProp: prop => prop !== 'hasBorder' && prop !== 'indicatorHeight',
})(props => ({
    borderBottom: props.hasBorder ? '1px solid #ededed' : '',
    minHeight: 40,
    '& .MuiTabs-indicator': {
        backgroundColor: '#8a00e5',
        height: props.indicatorHeight,
    },
}));
const AntTab = styled((props) => (React__default.createElement(Tab, { disableRipple: true, ...props })), {
    shouldForwardProp: prop => prop !== 'sideMargin' &&
        prop !== 'selectedHasBold' &&
        prop !== 'hasBold' &&
        prop !== 'minHeight',
})(({ theme, fontSize, minHeight, padding, sideMargin, hasBold, selectedHasBold, }) => ({
    textTransform: 'none',
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
        minWidth: 0,
    },
    marginRight: theme.spacing(sideMargin),
    marginLeft: theme.spacing(sideMargin),
    minHeight: minHeight,
    paddingLeft: padding,
    paddingRight: padding,
    fontWeight: hasBold
        ? theme.typography.fontWeightBold
        : theme.typography.fontWeightMedium,
    color: 'rgba(0, 0, 0, 0.85)',
    fontFamily: 'Siemens',
    fontSize: fontSize,
    '&:hover': {
        color: '#8a00e5',
        opacity: 1,
    },
    '&.Mui-selected': {
        color: '#8a00e5',
        fontWeight: hasBold || selectedHasBold
            ? theme.typography.fontWeightBold
            : theme.typography.fontWeightMedium,
    },
    '&.Mui-focusVisible': {},
}));
const Tabs = ({ data, onChange, onClick, onMouseOver, onMouseOut, selectedKey, hasBorder = true, indicatorHeight = 1.5, centered = true, scrollable = false, fontSize = 12, minHeight = 40, padding = 0, sideMargin = 2, hasBold = false, selectedHasBold = false, allowClickSelected = false, }) => {
    const [tabSelected, setTabSelected] = useState(selectedKey);
    const handleChange = (event, value) => {
        setTabSelected(value);
        if (onChange) {
            onChange(value);
        }
    };
    const handleClick = (value) => {
        if (value === tabSelected && allowClickSelected) {
            if (onChange) {
                onChange(value);
            }
        }
        if (onClick) {
            onClick(value);
        }
    };
    const handleMouseOver = (value) => {
        if (onMouseOver) {
            onMouseOver(value);
        }
    };
    const handleMouseOut = (value) => {
        if (onMouseOut) {
            onMouseOut(value);
        }
    };
    useEffect(() => {
        if (selectedKey)
            setTabSelected(selectedKey);
    }, [selectedKey]);
    return (React__default.createElement("div", { style: { fontFamily: 'Siemens', width: '100%', height: 40 } },
        React__default.createElement(AntTabs, { value: tabSelected, onChange: handleChange, centered: centered && !scrollable, indicatorHeight: indicatorHeight, hasBorder: hasBorder, variant: scrollable ? 'scrollable' : 'standard', scrollButtons: "auto", TabScrollButtonProps: { disableRipple: true } }, data.map(tab => (React__default.createElement(AntTab, { key: 'Tab__' + tab.key, label: tab.label, value: tab.key, wrapped: tab.wrapped || false, disabled: tab.disabled || false, fontSize: fontSize, minHeight: minHeight, padding: padding, sideMargin: sideMargin, hasBold: hasBold, selectedHasBold: selectedHasBold, onClick: () => handleClick(tab.key), onMouseOver: () => handleMouseOver(tab.key), onMouseOut: () => handleMouseOut(tab.key) }))))));
};

export { Tabs as default };
//# sourceMappingURL=Tabs.js.map
